<template>
  <div
    class="
      d-flex
      pa-10
      grey--text
      fill-height
      flex-column
      justify-center
      align-center
    "
  >
    <div class="text-center">Access denied.</div>
    <div class="text-center">{{ ip }}</div>
  </div>
</template>
<script>
export default {
  name: "access_denied",
  data: () => ({
    ip: "",
  }),
  mounted() {
    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.ip = ip;
      });
  },
};
</script>